import { render, staticRenderFns } from "./ClientSendtoInputComponent.vue?vue&type=template&id=7aa91961&"
import script from "./ClientSendtoInputComponent.vue?vue&type=script&lang=js&"
export * from "./ClientSendtoInputComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClientSendtoInputComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports